function waitForElement(selector, callback) {
  const element = document.querySelector(selector);

  if (element) {
    // If the element is already in the DOM, execute the callback immediately
    callback(element);
    return;
  }

  // Create a MutationObserver to monitor changes in the DOM
  const observer = new MutationObserver((mutationsList, observer) => {
    const targetElement = document.querySelector(selector);
    if (targetElement) {
      callback(targetElement);
      observer.disconnect(); // Stop observing once the element is found
    }
  });

  // Start observing the document for added nodes
  observer.observe(document.body, { childList: true, subtree: true });
}

document.addEventListener("DOMContentLoaded", function () {
  waitForElement(".offer-option-item", (element) => {
    element.style.display = "none";
    console.log("Element appeared:", element);
    const offerOptionItems = document.querySelectorAll(".offer-option-item");
    console.log('offeroptionlistlength', offerOptionItems.length)
    if (offerOptionItems.length == 2 && window.innerWidth > 1024){
      // Select the element
      const offerOptionsList = document.querySelector('.offer-options-list');
      
      // Apply grid styles
      offerOptionsList.style.display = 'grid';
      offerOptionsList.style.gridTemplateAreas = `
        "box1 box2"
        "box3 box3"
      `;
      offerOptionsList.style.gridTemplateColumns = '1fr 1fr'; // Two equal columns
      offerOptionsList.style.gap = '1rem'; // Space between items

     const button = document.querySelector('.offer-option-btn');
      button.style.gridArea = `box3`;
    }
    
    offerOptionItems.forEach((item, index) => {
      if (offerOptionItems.length == 2 && window.innerWidth > 1024) item.style.gridArea = `box${index+1}`;

      const offerOptionItemPrice = item.querySelector(".option-item-price");
      const offerOptionPrice = item.querySelector(".offer-option_price");
      const offerOptionTotalPrice = item.querySelector(".option-total-price");
      const offerOption = item.querySelector(".offer-option");
      const offerOptionTitle = offerOption.querySelector("p");
      const offerOptionTxt = item.querySelector(".offer-option_txt");
      const regularItemPrice = offerOptionItemPrice.querySelector(
        ".item-regular_price"
      );
      const span = document.createElement("span");
      offerOptionTitle.innerHTML = offerOptionTitle.innerHTML.replace(
        " ,",
        ","
      );
      span.innerHTML = "pro Stück";
      span.style.marginRight = "5px";
      offerOption.append(offerOptionItemPrice);
      offerOption.querySelector(".option-item-price").prepend(span);
      offerOptionTotalPrice.style.flexDirection = "column";
      offerOptionItemPrice.style.fontSize = "0.67rem";
      offerOptionItemPrice.style.width = "fit-content";
      offerOptionPrice.style.width = "fit-content";
      offerOptionTxt.style.width = "100%";
      offerOptionTotalPrice.style.marginTop = "0px";
      offerOptionTotalPrice.querySelector(
        ".total-regular_price"
      ).style.fontWeight = "bold";
      offerOption.style.width = "fit-content";
    });

    element.style.display = "block";
  });
});


function updateCartBubble(i) {
  const t = document.getElementById("CartBubble");
  i ? (t.classList.remove("hidden"), t.innerHTML = i) : (t.classList.add("hidden"), t.innerHTML = "")
}

function getAllCartItemsQuantity(){
  const items = document.querySelectorAll('.cart-modal-item');
  let quantity = 0;
  items.forEach(item=>{
    quantity = quantity + parseInt(item.getAttribute('data-cart-item-quantity'))
  })

  return quantity;
}

window.monster_refresh = function (){
  document.querySelector("cart-modal").reloadContent();
  setTimeout(function(){
    document.querySelector("cart-modal").reloadContent();
    document.querySelector('[target="#cart-modal"] a').click();
    updateCartBubble(getAllCartItemsQuantity());
  }, 1000);
}

function translateText(node) {
    if (node.nodeType === Node.TEXT_NODE) {
        node.textContent = node.textContent
            .replace(/\bTotal\b/g, "Gesamt")
            .replace(/\bBUY\b/g, "Kaufen")
            .replace(/\bGET\b/g, "Erhalte")
            .replace(/\bQty\b/g, "Anzahl")
            .replace(/\bFREE\b/g, "Kostenlos")
            .replace(/\bFree\b/g, "Kostenlos")
            .replace(/\bSubscribed\b/g, "Abonniert")
            .replace(/\bSubscribe and Save More\b/g, "Abonnieren und mehr sparen")
            .replace(/\bDeliver Every\b/g, "Lieferung")
            .replace(/\boff\b/g, "Rabatt");
    } else if (node.nodeType === Node.ELEMENT_NODE) {
        node.childNodes.forEach(translateText);
    }
}
function calculateAndStyleDiscount(node) {
  if (node.nodeType === Node.TEXT_NODE) {
    let textContent = node.textContent;

    // Check if the text content contains the discount markers
    if (textContent.includes('[DISCOUNT %]') ||
      textContent.includes('[DISCOUNT €]')) {

      // Find the _offerWrapperV2 parent
      let offerWrapper = findAncestor(node.parentNode,
        (el) => el.className && el.className.startsWith('_offerWrapperV2'));

      if (offerWrapper) {
        // Extract prices - using more robust selectors
        const pricingContainer = offerWrapper.querySelector(
          '[class^="_offerPricingContainerV2"]'
        );

        if (pricingContainer) {
          const discountedPriceElement = pricingContainer.querySelector(
            'div:first-child span span.hidePrice'
          );
          const originalPriceElement = pricingContainer.querySelector(
            'div[style*="line-through"] span span.hidePrice'
          );

          if (discountedPriceElement && originalPriceElement) {
            const discountedPriceText = discountedPriceElement.textContent;
            const originalPriceText = originalPriceElement.textContent;

            const discountedPrice = parseFloat(
              discountedPriceText.replace(/[^\d.]/g, '')
            );
            const originalPrice = parseFloat(
              originalPriceText.replace(/[^\d.]/g, '')
            );

            if (!isNaN(discountedPrice) && !isNaN(originalPrice)) {
              let discountValue;
              let discountType;

              if (textContent.includes('[DISCOUNT %]')) {
                discountValue = ((originalPrice - discountedPrice) /
                  originalPrice) * 100;
                discountType = '%';
              } else {
                discountValue = originalPrice - discountedPrice;
                discountType = '€';
              }
              
              console.log('Discount:', discountValue.toFixed(2), discountType);
              
              if(discountValue.toFixed(2) > 0){
                node.textContent = node.textContent.replace('[DISCOUNT %]', 'Sie sparen ' + discountValue.toFixed(0) + '' + discountType)
                node.textContent = node.textContent.replace('[DISCOUNT €]', 'Sie sparen ' + discountValue.toFixed(2) + '' + discountType)
              }
              

              // Apply style to the original text node's parent (optional)
              node.parentNode.style.backgroundColor = "#ca3311";
              node.parentNode.style.color = "white";
            } else {
              console.warn("Could not parse prices:", discountedPriceText,
                originalPriceText);
            }
          } else {
            console.warn("Could not find price elements in:", pricingContainer);
          }
        } else {
          console.warn("Could not find _offerPricingContainerV2 parent for:",
            offerWrapper);
        }
      } else {
        console.warn("Could not find _offerWrapperV2 parent for:", node);
      }
    }
  } else if (node.nodeType === Node.ELEMENT_NODE) {
    node.childNodes.forEach(calculateAndStyleDiscount);
  }
}

// Helper function to find an ancestor element
function findAncestor(el, test) {
  while ((el = el.parentNode) && !test(el));
  return el;
  }

function processDivs() {
    document.querySelectorAll('div[id^="kefi_"]').forEach(translateText);
    document.querySelectorAll('div[id^="kefi_"]').forEach(calculateAndStyleDiscount);
}

// Observer to detect new elements
const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.matches('div[id^="kefi_"]')) {
                    translateText(node);
                }
                node.querySelectorAll('div[id^="kefi_"]').forEach(translateText);
              if (node.matches('div[id^="kefi_"]')) {
                calculateAndStyleDiscount(node);
              }
              node.querySelectorAll('div[id^="kefi_"]').forEach(calculateAndStyleDiscount);
            }
        });
    });
});

// Start observing changes in the body
observer.observe(document.body, { childList: true, subtree: true });

// Translate already loaded elements
const initInterval = setInterval(processDivs, 1000);

setTimeout(function(){
  clearInterval(initInterval)
},5000)

document.addEventListener("DOMContentLoaded", function () {
    let cartCount = getAllCartItemsQuantity();
    let originalFavicon = document.querySelector("link[rel='icon']")?.href;
    let blinkInterval;
    let faviconIndex = 0;

    // Function to create and update favicon
    function updateFavicon(number, show) {
        cartCount = getAllCartItemsQuantity();
        let canvas = document.createElement("canvas");
        canvas.width = 64;
        canvas.height = 64;
        let ctx = canvas.getContext("2d");

        let img = new Image();
        img.src = originalFavicon;
        img.onload = function () {
            ctx.drawImage(img, 0, 0, 64, 64);

            if (number > 0 && show) {
                let badgeRadius = 20; // Radius of the circular badge
                let centerX = 24; // X position of the circle's center
                let centerY = 44; // Y position (towards the bottom of the favicon)

                // Draw the circular red badge
                ctx.fillStyle = "red";
                ctx.beginPath();
                ctx.arc(centerX, centerY, badgeRadius, 0, 2 * Math.PI);
                ctx.closePath();
                ctx.fill();

                // Add the number inside the circle
                ctx.fillStyle = "white";
                ctx.font = "bold 36px Arial"; // Large, bold font for the number
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";
                ctx.fillText(number, centerX - 2, centerY);
            }

            let favicon = document.querySelector("link[rel='icon']");
            if (!favicon) {
                favicon = document.createElement("link");
                favicon.rel = "icon";
                document.head.appendChild(favicon);
            }
            favicon.href = canvas.toDataURL("image/png");
        };
    }

    // Start blinking effect when tab is inactive
    function startBlinking() {
        cartCount = getAllCartItemsQuantity();
        blinkInterval = setInterval(() => {
            if (faviconIndex % 2 === 0) {
                updateFavicon(cartCount,true);
            } else {
                updateFavicon(0, false);
            }
            faviconIndex++;
        }, 800);
    }

    // Stop blinking and reset favicon when tab is active
    function stopBlinking() {
        clearInterval(blinkInterval);
        updateFavicon(cartCount, false);
    }

    document.addEventListener("visibilitychange", function () {
        if (document.hidden) {
            startBlinking();
        } else {
            stopBlinking();
        }
    });

    // Initial update
    updateFavicon(cartCount, false);
});